export default "__VITE_ASSET__EMAdKsQV__"